import PropTypes from "prop-types"
import React, { Component } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { I18nextProvider } from "react-i18next"
import IdleTimer from "react-idle-timer"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Col } from "reactstrap"
import i18n from "../../i18n"
import {
  changeLayout,
  changeLayoutWidth,
  changeTopbarTheme,
  toggleRightSidebar,
} from "../../store/actions"
import Rightbar from "../CommonForBoth/Rightbar"
import Footer from "./Footer"
import Header from "./Header"
// Other Layout related Component
import Navbar from "./Navbar"

class Layout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMenuOpened: false,
      timeout: 1000 * 2000 * 1,
      userLoggedIn: false,
      isTimedOut: false,
      confirm: null,
      dynamic_description: "",
      dynamic_title: "",
      success_dlg: null,
      error_dlg: null,
    }

    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this)
  }

  _onAction(e) {
    console.log("user did something", e)
    this.setState({ isTimedOut: false })
  }

  _onActive(e) {
    console.log("user is active", e)
    this.setState({ isTimedOut: false })
  }

  _onIdle(e) {
    console.log("user is idle", e)
    const isTimedOut = this.state.isTimedOut
    if (isTimedOut) {
      this.props.history.push("/lock-screen")
    } else {
      this.setState({ confirm: true })
      this.idleTimer.reset()
      this.setState({ isTimedOut: true })
    }
  }

  handleClose() {
    this.setState({ confirm: false })
  }

  handleLogout() {
    this.setState({ confirm: false })
    this.props.history.push("/lock-screen")
  }

  /**
   * Open/close right sidebar
   */
  toggleRightSidebar() {
    this.props.toggleRightSidebar()
  }

  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }

    // Scrollto 0,0
    window.scrollTo(0, 0)

    const title = this.props.location.pathname
    let currentage = title.charAt(1).toUpperCase() + title.slice(2)

    document.title = currentage + " | Vomoz - Dashboard"

    this.props.changeLayout("horizontal")
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme)
    }
    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth)
    }
    if (this.props.showRightSidebar) {
      this.toggleRightSidebar()
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = e => {
    this.setState({ ...this.state, isMenuOpened: !this.state.isMenuOpened })
  }
  render() {
    const { match } = this.props
    const { confirm } = this.state
    return (
      <React.Fragment>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={this.state.timeout}
        />

        <I18nextProvider i18n={i18n}>
          <div id="preloader">
            <div id="status">
              <div className="spinner-chase"></div>
            </div>
          </div>
          <div id="layout-wrapper">
            <Header
              theme={this.props.topbarTheme}
              isMenuOpened={this.state.isMenuOpened}
              toggleRightSidebar={this.toggleRightSidebar}
              openLeftMenuCallBack={this.openMenu}
            />
            <Navbar menuOpen={this.state.isMenuOpened} />
            <div className="main-content">{this.props.children}</div>
            <Footer />
          </div>
          <Rightbar />
        </I18nextProvider>
        <Col xl="3" lg="4" sm="6" className="mb-2">
          {confirm && (
            <SweetAlert
              warning
              showCancel
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={this.handleClose}
              onCancel={() => this.setState({ confirm: false })}
              confirmBtnText="Stay Connected"
              cancelBtnText="Logout"
              title="Your Session is About to Expire!"
              timeout={3000}
            >
              Redirecting in 5s seconds.<br></br>
            </SweetAlert>
          )}
        </Col>
      </React.Fragment>
    )
  }
}

Layout.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.bool,
  layoutWidth: PropTypes.string,
  location: PropTypes.object,
  showRightSidebar: PropTypes.func,
  toggleRightSidebar: PropTypes.func,
  topbarTheme: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    ...state.Layout,
  }
}
export default connect(mapStateToProps, {
  changeTopbarTheme,
  toggleRightSidebar,
  changeLayout,
  changeLayoutWidth,
})(withRouter(Layout))
